import gql from 'graphql-tag';

export const removePropertyExternalReferences = gql(/* GraphQL */ `
  mutation removePropertyExternalReferences(
    $channelId: UUID!
    $externalReferences: [ExternalReferenceRemoveInput!]!
  ) {
    removePropertyExternalReferences(
      channelId: $channelId
      externalReferences: $externalReferences
    ) {
      successful {
        id
        direct
        source {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        relationshipSource {
          sourceType
          sourceRelationshipType
          sourceRelationshipId
        }
      }
      failed {
        source {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        relationshipSource {
          sourceType
          sourceRelationshipType
          sourceRelationshipId
        }
      }
    }
  }
`);
